import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { clientAuthDetailsLabel} from "../../../../utilities/Constants";
import { EAuthStatusMessageFields } from "../../../../../create-request/models/internal-transfer/InternalTransferInquiryResponse";
import { selectEAuthCustomers } from "projects/money-movement-ui/src/app/account-info-header/reducers";
import { selectEAuthInfo } from "../../../../reducers";
import { Store } from "@ngrx/store";
import { combineLatest, Subject, takeUntil } from "rxjs";


@Component({
  standalone: false,
    selector: 'mm-condensed-eauth-section',
    templateUrl: './condensed-eauth-section.component.html',
    styleUrls: ['./condensed-eauth-section.component.scss']
})

export class CondensedEauthSectionComponent implements OnInit, OnDestroy {
    @Input() customerList: EAuthStatusMessageFields[] = [];
    readonly labels = clientAuthDetailsLabel;
    

    authorizors: {['name']: string, ['email']: string }[] = [];

    destroy$ = new Subject<void>();
    
    constructor(private store: Store) { }

    ngOnInit(): void {
        if (this.customerList?.length > 0) {
            this.customerList.forEach((customer) => {
                this.authorizors.push({
                    name: `${customer.firstName} ${customer.lastName}`,
                    email: customer.emailId ?? ''
                });
            });
        } else {
            combineLatest([
                this.store.select(selectEAuthCustomers),
                this.store.select(selectEAuthInfo)
            ]).pipe(takeUntil(this.destroy$)).subscribe(([customerList, eAuthInfo]) => {
                eAuthInfo.selectedAccountHolder?.forEach((accountHolder) => {  
                    this.authorizors = []; 
                    let selectedAccountHolder = customerList?.find(customer => customer.customerId === accountHolder);
                    if (selectedAccountHolder) {
                        this.authorizors.push({
                            name: `${selectedAccountHolder.firstName} ${selectedAccountHolder.lastName}`,
                            email: selectedAccountHolder.emailId
                        });
                    }
                });
            });
        }
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}